import { showPasswordToggler } from '../../../__assets__/scripts/show-password-button'
import { handleForm } from '../../../__assets__/scripts/input-form'
import { initRatesWidget } from '../../../__assets__/scripts/four-main-currencies-widget'
import { spawnTrackingEventListners } from '../../../../assets/scripts/components/tracking-ga-events'
import cookieConsent from 'services/cookies-consent'
init()

function init(): void {
  // Init 4 main currency widget
  initRatesWidget()

  // Add show password behavior
  showPasswordToggler()

  // Registry Form
  handleForm()

  // set GA/GTM events tracking
  spawnTrackingEventListners()

  // cookiebot banner
  cookieConsent.init()
}
